'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAccount = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(UserAccount, _React$Component);

  function UserAccount() {
    (0, _classCallCheck3.default)(this, UserAccount);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserAccount.__proto__ || (0, _getPrototypeOf2.default)(UserAccount)).call(this));

    _this.state = {
      showForm: false,
      password: '',
      rePassword: '',
      passwordError: null
    };
    return _this;
  }

  (0, _createClass3.default)(UserAccount, [{
    key: 'onChangeClick',
    value: function onChangeClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.UpdatePasswordDialog, null));
    }
  }, {
    key: 'onPasswordChange',
    value: function onPasswordChange(password) {
      this.setState((0, _extends3.default)({}, this.state, { password: password }));
    }
  }, {
    key: 'onRePasswordChange',
    value: function onRePasswordChange(password) {
      this.setState((0, _extends3.default)({}, this.state, { rePassword: password }));
    }
  }, {
    key: 'onCancelClick',
    value: function onCancelClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.setState((0, _extends3.default)({}, this.state, { showForm: false, password: '', rePassword: '', passwordError: null }));
    }
  }, {
    key: 'onLoginClick',
    value: function onLoginClick(e) {
      e.preventDefault();
      e.stopPropagation();

      var _state = this.state,
          password = _state.password,
          rePassword = _state.rePassword;


      var passwordLengthValid = password.length >= 6;
      var passwordsMatch = password === rePassword;

      if (!passwordLengthValid) {
        return this.setState({
          passwordError: 'Please make sure that the password is at least 6 characters long.'
        });
      }

      if (!passwordsMatch) {
        return this.setState({
          passwordError: 'Please make sure that both passwords match.'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./UserAccount.scss');

      var _state2 = this.state,
          showForm = _state2.showForm,
          passwordError = _state2.passwordError;
      var auth = this.props.auth;

      var email = auth && auth.user && auth.user.email;

      return _react2.default.createElement(
        _components.InfoBox,
        { title: 'Account Details', icon: '/icons/security.svg' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(
              'span',
              { className: '' + styles.userid },
              email
            )
          ),
          _react2.default.createElement(
            'div',
            { className: '' + styles.padding16 },
            _react2.default.createElement(
              'div',
              { className: styles['col-md-12'] },
              _react2.default.createElement(
                'div',
                { className: styles.row },
                _react2.default.createElement(_components.Button, { secondary: true, fullWidth: true, label: 'Change Password', onClick: this.onChangeClick.bind(this) })
              )
            )
          )
        )
      );
    }
  }]);
  return UserAccount;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var UserAccountContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}), _dec(_class2 = function (_React$Component2) {
  (0, _inherits3.default)(UserAccountContainer, _React$Component2);

  function UserAccountContainer() {
    (0, _classCallCheck3.default)(this, UserAccountContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserAccountContainer.__proto__ || (0, _getPrototypeOf2.default)(UserAccountContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserAccountContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          auth = _props.auth;


      return _react2.default.createElement(UserAccount, { auth: auth });
    }
  }]);
  return UserAccountContainer;
}(_react2.default.Component)) || _class2);
exports.default = UserAccountContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAccount/UserAccount.jsx
// module id = 2697
// module chunks = 0